module.exports = __webpack_public_path__ + "static/media/um.23f83ac4.svg";